import { Modal as CompassModal } from "@circleco/compass/components/Modal";

import { t } from "@/i18n-js/instance";
import type { ConfirmationModalProps } from "@/react/components/SettingsApp/CompassCompat/ConfirmationModal";

import { toCompassSize, toCompassVariant } from "../modalHelpers";

export const CompassConfirmationModal = ({
  cancelText = t("cancel"),
  children,
  confirmText = t("confirm"),
  confirmVariant,
  dataTestId,
  disabled,
  loading,
  formId,
  isOpen,
  onCancel,
  onClose,
  onConfirm,
  size,
  title,
}: ConfirmationModalProps) => {
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose?.();
    }
  };

  const handleSecondaryClick = () => {
    if (onCancel) {
      onCancel();
    } else {
      onClose?.();
    }
  };

  const handlePrimaryClick = () => {
    onConfirm?.();
  };

  const compassSize = toCompassSize(size);
  const compassVariant = toCompassVariant(confirmVariant);

  return (
    <CompassModal.Root
      open={isOpen}
      onOpenChange={handleOpenChange}
      size={compassSize}
    >
      <CompassModal.Content>
        <CompassModal.Header
          title={title}
          showCloseButton={!!onClose && !loading}
        />
        <CompassModal.Body>{children}</CompassModal.Body>
        <CompassModal.Footer
          secondaryAction={
            (onCancel || onClose) && !loading
              ? {
                  label: cancelText,
                  onClick: handleSecondaryClick,
                  shouldCloseModal: false,
                }
              : undefined
          }
          primaryAction={{
            label: confirmText,
            variant: compassVariant,
            disabled,
            loading,
            onClick: handlePrimaryClick,
            type: formId ? "submit" : "button",
            form: formId,
            "data-testid": dataTestId,
          }}
        />
      </CompassModal.Content>
    </CompassModal.Root>
  );
};
